
import XInput from 'vux/src/components/x-input/index.vue'

export default {
components: {
XInput
},
props: {
fields: {
type: Array,
required: true,
default: () => []
}
},
data () {
return {
formData: {}, // 用來存儲每個輸入框的值
errors: {}
}
},
created () {
this.fields.forEach((field) => {
this.formData[field.name] = ''
this.errors[field.name] = null
})
},
methods: {
validator (field) {
const regex = new RegExp(field.regex)
if (!regex.test(this.formData[field.name])) {
this.$set(this.errors, field.name, `${this.$t(`${field.name}`)} ${this.$t('formatWrong')}`)
} else {
this.$delete(this.errors, field.name)
}
}
},
watch: {
formData: {
deep: true,
handler (newFormData) {
this.$emit('update:formData', newFormData)
this.$emit('update:errors', this.errors)
}
}
}
}



// WEBPACK FOOTER //
// ./src/components/DynamicInput.vue